import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
/* Layout */
import Layout from '@/layouts/default'
// 教师路由
export const teacher = [
  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: '/',
        component: () => import('@/views/index.vue'),
        name: 'Course',
        meta: { title: '首页', icon: 'dashboard', affix: true },
      },
      {
        path: '/course',
        component: () => import('@/views/course/index.vue'),
        name: 'Course',
        meta: { title: '我的课程', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/courselist',
        component: () => import('@/views/course/courselist.vue'),
        name: 'Courselist',
        meta: { title: '课程详情', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/baseinfo',
        component: () => import('@/views/courseinfo/baseinfo'),
        name: 'baseinfo',
        meta: { title: '课程介绍', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/baseinfo/standard',
        component: () => import('@/views/courseinfo/baseinfo/standard.vue'),
        name: 'standard',
        meta: { title: '补充信息', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/baseinfo/supplement',
        component: () => import('@/views/courseinfo/baseinfo/supplement.vue'),
        name: 'supplement',
        meta: { title: '评分标准', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/baseinfo/teaching',
        component: () => import('@/views/courseinfo/baseinfo/teaching.vue'),
        name: 'teaching',
        meta: { title: '教材', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/team',
        component: () => import('@/views/courseinfo/team'),
        name: 'team',
        meta: { title: '团队', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/courseware',
        component: () => import('@/views/courseinfo/courseware'),
        name: 'courseware',
        meta: { title: '课件', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/interaction',
        component: () => import('@/views/courseinfo/interaction'),
        name: 'interaction',
        meta: { title: '互动', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/questionbank',
        component: () => import('@/views/courseinfo/questionbank'),
        name: 'questionbank',
        meta: { title: '题库', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/job',
        component: () => import('@/views/courseinfo/job'),
        name: 'Job',
        meta: { title: '作业', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/exam',
        component: () => import('@/views/courseinfo/exam'),
        name: 'Exam',
        meta: { title: '考试', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/researchpage',
        component: () => import('@/views/courseinfo/researchpage'),
        name: 'researchpage',
        meta: { title: '课表模版', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/coursecatalogue',
        component: () => import('@/views/courseinfo/coursecatalogue'),
        name: 'coursecatalogue',
        meta: { title: '课程目录', icon: 'dashboard', affix: true },
      },
      {
        path: '/courseinfo/live',
        component: () => import('@/views/courseinfo/live'),
        name: 'live',
        meta: { title: '直播', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/classwork',
        component: () => import('@/views/course/classwork.vue'),
        name: 'classwork',
        meta: { title: '班级作业', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/classexamination',
        component: () => import('@/views/course/classexamination.vue'),
        name: 'classexamination',
        meta: { title: '班级考试', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/statistics',
        component: () => import('@/views/course/statistics.vue'),
        name: 'statistics',
        meta: { title: '班级考试统计', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/messagepage',
        component: () => import('@/views/course/messagepage'),
        name: 'messagepage',
        meta: { title: '消息通知', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/classanalysis',
        component: () => import('@/views/course/classanalysis'),
        name: 'classanalysis',
        meta: { title: '统计分析', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/achievement',
        component: () => import('@/views/course/achievement'),
        name: 'achievement',
        meta: { title: '班级成绩', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/criterion',
        component: () => import('@/views/course/criterion'),
        name: 'criterion',
        meta: { title: '考核权重', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/managestudents',
        component: () => import('@/views/course/managestudents'),
        name: 'managestudents',
        meta: { title: '学生管理', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/classschedule',
        component: () => import('@/views/course/classschedule'),
        name: 'classschedule',
        meta: { title: '课表管理', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/preparelessons',
        component: () => import('@/views/course/preparelessons'),
        name: 'preparelessons',
        meta: { title: '备课管理', icon: 'dashboard', affix: true },
      },
      // 上课板块
      {
        path: '/attendclass/blackboard',
        component: () => import('@/views/attendclass/blackboard'),
        name: 'blackboard',
        meta: { title: '白板', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/courseware',
        component: () => import('@/views/attendclass/courseware'),
        name: 'attcourseware',
        meta: { title: '课件', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/signin',
        component: () => import('@/views/attendclass/signin'),
        name: 'signin',
        meta: { title: '签到', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/remarkon',
        component: () => import('@/views/attendclass/remarkon'),
        name: 'remarkon',
        meta: { title: '点评', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/quiz',
        component: () => import('@/views/attendclass/quiz'),
        name: 'quiz',
        meta: { title: '提问', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/testing',
        component: () => import('@/views/attendclass/testing'),
        name: 'testing',
        meta: { title: '测验', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/homework',
        component: () => import('@/views/attendclass/homework'),
        name: 'homework',
        meta: { title: '作业讲解', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/pkpage',
        component: () => import('@/views/attendclass/pkpage'),
        name: 'pkpage',
        meta: { title: '小组pk', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/vote',
        component: () => import('@/views/attendclass/vote'),
        name: 'vote',
        meta: { title: '投票', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/discussion',
        component: () => import('@/views/attendclass/discussion'),
        name: 'discussion',
        meta: { title: '讨论', icon: 'dashboard', affix: true },
      },
      {
        path: '/attendclass/brainstorming',
        component: () => import('@/views/attendclass/brainstorming'),
        name: 'brainstorming',
        meta: { title: '头脑风暴', icon: 'dashboard', affix: true },
      },
      {
        path: '/course/classroomanalysis',
        component: () => import('@/views/course/classroomanalysis'),
        name: 'classroomanalysis',
        meta: { title: '分析', icon: 'dashboard', affix: true },
      },
      // 作业板块
      {
        path: '/jobpage',
        component: () => import('@/views/jobpage/index.vue'),
        name: 'Jobpage',
        meta: { title: '全部作业', icon: 'dashboard', affix: true },
      },
      {
        path: '/jobpage/jobpageDetail',
        component: () => import('@/views/jobpage/jobpageDetail.vue'),
        name: 'jobpageDetail',
        meta: { title: '考试列表', icon: 'dashboard', affix: true },
      },
      {
        path: '/jobpage/correct',
        component: () => import('@/views/jobpage/correct.vue'),
        name: 'correct',
        meta: { title: '作业批改', icon: 'dashboard', affix: true },
      },
      // 考试板块
      {
        path: '/examinationpage',
        component: () => import('@/views/examinationpage/index.vue'),
        name: 'Examinationpage',
        meta: { title: '考试', icon: 'dashboard', affix: true },
      },
      {
        path: '/examinationpage/examinationDetail',
        component: () =>
          import('@/views/examinationpage/examinationDetail.vue'),
        name: 'examinationDetail',
        meta: { title: '考试列表', icon: 'dashboard', affix: true },
      },
      {
        path: '/examinationpage/correct',
        component: () => import('@/views/examinationpage/correct.vue'),
        name: 'examcorrect',
        meta: { title: '考试批改', icon: 'dashboard', affix: true },
      },
      // 资源板块
      {
        path: '/resource',
        component: () => import('@/views/resource'),
        name: 'resource',
        meta: { title: '资源管理', icon: 'dashboard', affix: true },
      },
      {
        path: '/resource/resourceDetail',
        component: () => import('@/views/resource/resourceDetail'),
        name: 'resourceDetail',
        meta: { title: '资源详情', icon: 'dashboard', affix: true },
      },
      // 教材板块
      {
        path: '/textbook',
        component: () => import('@/views/textbook'),
        name: 'textbook',
        meta: { title: '课程中心', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/coursedte',
        component: () => import('@/views/textbook/coursedte'),
        name: 'coursedte',
        meta: { title: '课程详情', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/search',
        component: () => import('@/views/textbook/search'),
        name: 'search',
        meta: { title: '全部课程', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/chatteacher',
        component: () => import('@/views/textbook/chatteacher'),
        name: 'chatteacher',
        meta: { title: 'AI文库', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/coursevideo',
        component: () => import('@/views/textbook/coursevideo'),
        name: 'coursevideoindex',
        meta: { title: '课程视频', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/onlinevideo',
        component: () => import('@/views/textbook/coursevideo/onlinevideo'),
        name: 'onlinevideo',
        meta: { title: '', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/readingpage',
        component: () => import('@/views/textbook/readingpage/index.vue'),
        name: 'readingpage',
        meta: { title: '知识图谱', icon: 'dashboard', affix: true },
      },
      // 个人中心
      {
        path: '/user',
        component: () => import('@/views/user'),
        name: 'user',
        meta: { title: '个人中心', icon: 'dashboard', affix: true },
      },
      {
        path: '*',
        redirect: '/404',
      },
    ],
  },
]
// 学生路由
export const student = [
  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: '/',
        component: () => import('@/views/stucourse'),
        meta: { title: '我的课程' },
        hidden: true,
      },
      {
        path: '/stucourse/stucourse',
        component: () => import('@/views/stucourse/stucourse'),
        meta: { title: '课程详情' },
        hidden: true,
      },
      {
        path: '/jobpage',
        component: () => import('@/views/jobpage/index.vue'),
        name: 'Jobpage',
        meta: { title: '全部作业', icon: 'dashboard', affix: true },
      },
      {
        path: '/jobpage/jobcenter',
        component: () => import('@/views/jobpage/stucenter.vue'),
        name: 'jobcenter',
        meta: { title: '作业中心', icon: 'dashboard', affix: true },
      },
      {
        path: '/stucourse/stuschedule',
        component: () => import('@/views/stucourse/stuschedule'),
        meta: { title: '课表' },
        hidden: true,
      },
      {
        path: '/stucourse/stuclass',
        component: () => import('@/views/stucourse/stuclass'),
        meta: { title: '课堂' },
        hidden: true,
      },
      {
        path: '/course/stulive',
        component: () => import('@/views/stucourse/stulive.vue'),
        meta: { title: '直播' },
        hidden: true,
      },
      {
        path: '/announcement',
        component: () => import('@/views/announcement'),
        meta: { title: '公告' },
        hidden: true,
      },
      {
        path: '/activity',
        component: () => import('@/views/activity'),
        meta: { title: '活动中心' },
        hidden: true,
      },
      {
        path: '/examination',
        component: () => import('@/views/examination'),
        meta: { title: '考试中心' },
        hidden: true,
      },
      {
        path: '/examination/examinationcenter',
        component: () => import('@/views/examination/examinationcenter'),
        meta: { title: '进入考试' },
        hidden: true,
      },
      // 个人中心
      {
        path: '/user',
        component: () => import('@/views/user'),
        name: 'user',
        meta: { title: '个人中心', icon: 'dashboard', affix: true },
      },
      // 教材板块
      {
        path: '/textbook',
        component: () => import('@/views/textbook'),
        name: 'textbook',
        meta: { title: '课程中心', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/coursedte',
        component: () => import('@/views/textbook/coursedte'),
        name: 'coursedte',
        meta: { title: '课程详情', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/search',
        component: () => import('@/views/textbook/search'),
        name: 'search',
        meta: { title: '全部课程', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/chatteacher',
        component: () => import('@/views/textbook/chatteacher'),
        name: 'chatteacher',
        meta: { title: 'AI文库', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/coursevideo',
        component: () => import('@/views/textbook/coursevideo'),
        name: 'coursevideoindex',
        meta: { title: '课程视频', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/onlinevideo',
        component: () => import('@/views/textbook/coursevideo/onlinevideo'),
        name: 'onlinevideo',
        meta: { title: '', icon: 'dashboard', affix: true },
      },
      {
        path: '/textbook/readingpage',
        component: () => import('@/views/textbook/readingpage/index.vue'),
        name: 'readingpage',
        meta: { title: '知识图谱', icon: 'dashboard', affix: true },
      },
      {
        path: '*',
        redirect: '/404',
      },
    ],
  },
]
// 公共路由
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' },
    hidden: true,
  },
  {
    path: '/registerpage',
    component: () => import('@/views/login/registerpage.vue'),
    meta: { title: '注册' },
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    meta: { title: '404' },
    hidden: true,
  },
]
// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err)
}

const createRouter = () =>
  new Router({
    routes: constantRoutes, //只挂载静态路由!
    mode: 'hash', // 去掉url中的#
  })
const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
export default router
